export const ACTION_CHOICES = [
  { id: 'create', name: 'Create' },
  { id: 'update', name: 'Update' },
  { id: 'delete', name: 'Delete' },
];

export const ENTITY_TYPE_CHOICES = [
  { id: 'action_logs', name: 'Action Logs' },
  { id: 'affiliate_networks', name: 'Affiliate Networks' },
  { id: 'bids', name: 'Bids' },
  { id: 'billing_items', name: 'Billing Items' },
  { id: 'categories', name: 'Categories' },
  { id: 'clicks', name: 'Clicks' },
  { id: 'feeds', name: 'Feeds' },
  { id: 'images', name: 'Images' },
  { id: 'invoices', name: 'Invoices' },
  { id: 'labels', name: 'Category Labels' },
  { id: 'label_values', name: 'Category Label Values' },
  { id: 'manufacturers', name: 'Manufacturers' },
  { id: 'mapping_rules', name: 'Mapping Rules' },
  { id: 'merchant_remarks', name: 'Merchant Remarks' },
  { id: 'merchant_statuses', name: 'Merchant Statuses' },
  { id: 'merchants', name: 'Merchants' },
  { id: 'offers', name: 'Offers' },
  { id: 'pay_accounts', name: 'Pay Accounts' },
  { id: 'payments', name: 'Payments' },
  { id: 'price_histories', name: 'Price Histories' },
  { id: 'products', name: 'Products' },
  { id: 'product_labels', name: 'Product Labels' },
  { id: 'regions', name: 'Regions' },
  { id: 'registrations', name: 'Registrations' },
  { id: 'reports', name: 'Reports' },
  { id: 'subscriptions', name: 'Subscriptions' },
];

export const ENTITY_TYPE_LABELS = new Map(
  ENTITY_TYPE_CHOICES.map((choice) => [choice.id, choice.name]),
);
